import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API, timeout: 30000 });

api.interceptors.request.use((cfg) => {
  // Prefer already-set Authorization header (from AuthContext), else look up localStorage
  if (!cfg.headers.Authorization) {
    const url = cfg.url || "";
    // Admin routes need the admin token: a member token (joh_auth_token) is a valid JWT
    // but gets rejected with 403 "Admin access required".
    const isAdminReq = url.startsWith("/admin") || url.startsWith("/jace") || url.startsWith("/auth/magic-link") || url.startsWith("/project11/admin");
    const isP11Req = url.startsWith("/project11") && !isAdminReq;
    const token = isAdminReq
      ? localStorage.getItem("joh_admin_token") || localStorage.getItem("joh_auth_token")
      : isP11Req
        ? localStorage.getItem("p11_token") || localStorage.getItem("joh_auth_token")
        : localStorage.getItem("joh_auth_token") || localStorage.getItem("joh_admin_token");
    if (token) cfg.headers.Authorization = `Bearer ${token}`;
  }
  return cfg;
});
